{
  "version": 1,
  "asset_id": "74365bfb-88c3-41f3-bb21-a5bc9585be01",
  "project_id": "821317bb-5c16-42f2-91c7-33504f8f052a",
  "url": "/__l5e/assets-v1/74365bfb-88c3-41f3-bb21-a5bc9585be01/entertainment-tv.png",
  "r2_key": "a/v1/821317bb-5c16-42f2-91c7-33504f8f052a/74365bfb-88c3-41f3-bb21-a5bc9585be01/entertainment-tv.png",
  "original_filename": "entertainment-tv.png",
  "size": 251094,
  "content_type": "image/png",
  "created_at": "2026-06-26T13:35:47Z"
}
